<template>
  <div :class="['gridly-box',showOnly?'postages-showonly':'']">
    <div id="Logistics" class="mng-row">
      <el-form ref="CreateCardForm" :model="FormData" :rules="rules">
        <div v-if="FormData['CommunityPostages']">
          <div v-for="(ex, key) in FormData['CommunityPostages']" :key="key" class="delivery-box">
            <div class="row-step row-step-flex" style="text-transform: capitalize;">
              <span class="text_gray">{{ key==0 ? ex.AreaName+' ' : 'Excluded locations' }}<em class="isRequired-mark">*</em></span>
              <div class="flex-box" v-if="key > 0 && !showOnly">
                <span @click="AddExcluded(key)">Edit</span><span @click="DelExcluded(key)">Delete</span>
              </div>
            </div>
            <div class="row-gray" v-if="key>0">

              <el-form-item v-bind:prop="'CommunityPostages.'+key+'.AreaID'" :rules="formRule('AreaID')">
                <span>{{ ex.AreaName }}</span>
              </el-form-item>
              <!-- <span>{{ ex.AreaName }}</span> -->
            </div>
            <div class="custom-box gu-money freight-row row-block">
              <el-radio-group v-model="ex['Status']" v-on:change="ExcludedStatus(key)" class="gu-money-radio" :disabled="showOnly">
                <el-form-item v-bind:prop="'CommunityPostages.'+key+'.Status'"
                  v-bind:rules="[{ required: true, message: 'Please choose shipping fee!', trigger: ['change', 'blur'] }]"><!-- 请选择运费方式 -->
                  <el-radio :label="1">Free For Buyer</el-radio>
                  <!-- <el-radio :label="2">顺丰到付</el-radio> -->
                  <el-radio :label="3">Buyer Pays</el-radio>
                </el-form-item>
              </el-radio-group>
              <div class="gu-money-yes" v-if="ex['Status']==3">
                <el-form-item v-bind:prop="'CommunityPostages.'+key+'.Price'"
                  v-bind:rules="[{ required: true, pattern: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/, message: 'Price must be higher than 0', trigger: ['change', 'blur'] }]"><!-- 价格不能低于0 -->
                  $<input type="number" class="ctg-input ctg-input-numb" v-model="ex['Price']" :disabled="showOnly" pattern="[1-999999]"
                    min="1" max="999999" v-on:change="ExcludedPrice(key)" />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div v-if="!showOnly" class="delivery-box MoreExcluded" @click="ExcludedYes()">
        + More Other Location Rules
      </div>
    </div>
    <el-dialog title="Please province selection" :visible.sync="dialogVisible" width="970px">
      <div class="ExcludedDialog">
        <div class="ex-box">
          <div v-if="ChinaArea.length">
            <div class="ex-list" v-for="(obj, key) in ChinaArea" :key="key" :index="key">
              <div class="ex-list-tag">{{ obj.name }}</div>
              <div class="ex-list-name">
                <div class="area-block" v-for="(ar, k) in obj.area" :key="k" :index="k"
                  v-bind:class="[tempArea['k-' + key + '-' + k] ? 'active' : '',curPostages.indexOf(ar.Code) > -1 &&!tempArea['k-' + key + '-' + k]? 'disActice': '',]"
                  @click="selectArea(ar,key,k,tempArea['k-' + key + '-' + k] ? 'delt' : 'add',curPostages.indexOf(ar.Code) > -1 &&!tempArea['k-' + key + '-' + k]? 'disable': '')">
                  <span>{{ ar.EName }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ExcludedDialog Excludedbtn">
        <div @click="ExcludedYes()">OK</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../common/util";
export default {
  name: 'CommunityPostages',
  data() {
    return {
      ChinaArea: [],
      rules: util.rule("formRule"), //验证规则
      dialogVisible: false,
      E_item: "",
      Excluded: [{ ex: 0, name: "" }],
      ChinaArea: [], //省直辖市
      tempArea: {}, //临时省直辖市（选中）
      tempAreaArr: [], //临时省直辖市（array 用于遍历）
      curPostages: [], //当前已选所有区域
      FormData: {
        CommunityPostages: []
      }
    }
  },
  props: {
    showOnly: false//是否纯显示
  },
  watch: {

  },
  created: function () {
    var that = this;
    that.getData("GetChinaArea");
    that.getData("GetMemberAddress");
  },
  mounted(){
    
  },
  computed: {
    formRule: function () {
      var that = this;
      return function (type) {
        let r = [
          {
            validator: function (rule, value, callback) {
              if (value == "") {
                callback(new Error("Please select the locations"));
              } else {
                callback();
              }
            },
            trigger: ['change', 'blur']
          }];
        return r;
      }
    }
  },
  methods: {
    getData(api, data = "", key, saveContinue) {
      var that = this;
      var fun = "", method = "GET";
      switch (api) {
        case "GetChinaArea": //获取国内所有省直辖市
          that.$get(api, data)
            .then((res) => {
              // console.log("axios-res:", api, res);
              if (res.result) {
                var _data = res.data;
                var _ChinaArea = util.areaReconfig(_data); //省直辖市 结构重组
                that.ChinaArea = _ChinaArea;
                //console.log("CardDetail-ChinaArea", _ChinaArea);
              }
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case "GetMemberAddress": //获取快递模板信息
          that.$get(api, data)
            .then((res) => {
              // console.log("axios-res:", api, res);
              if (res.result) {
                let _data = res.data, CommunityPostages = res.data;
                _data.map((obj, k) => {
                  if (obj.Price > 0) {
                    CommunityPostages[k]['Price'] = that.$store.getters.priceExchange(obj.Price, 'USD');
                  }
                });
                that.$set(that.FormData, 'CommunityPostages', CommunityPostages)
              }
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        default:
          break;
      }
    },
    //运费方式
    ExcludedStatus(index) {
      var that = this;
      //console.log('ExcludedStatus, ', index, that.FormData['CommunityPostages'][index]);
      if (index != undefined) {
        var _CCP = that.FormData["CommunityPostages"][index];
        _CCP["Price"] = 0; //切换包邮 价格 0
        that.$set(that.FormData["CommunityPostages"], index, _CCP);
        that.$set(that.FormData, "AddressVersionCode", ""); //有编辑运费 清空AddressVersionCode
      }
    },
    //运费价格
    ExcludedPrice(index) {
      var that = this;
      //console.log('ExcludedPrice, ', index, that.FormData['CommunityPostages'][index]);
      if (index != undefined) {
        var _CCP = that.FormData["CommunityPostages"][index];
        _CCP["Price"] = parseFloat(_CCP['Price']);//parseInt(_CCP['Price']);//int float
        that.$set(that.FormData["CommunityPostages"], index, _CCP);
        that.$set(that.FormData, "AddressVersionCode", ""); //有编辑运费 清空AddressVersionCode
      }
    },
    AddExcluded(index) {
      var that = this;
      //添加、编辑区域弹框
      that.tempArea = {};
      that.tempAreaArr = []; //清空临时显示区域
      if (index != undefined) {
        //编辑
        that.E_item = index;
        var _CommunityPostages = that.FormData["CommunityPostages"][index];
        if (_CommunityPostages["AreaID"] != "0") {
          //遍历已选区域
          var _areaIds = _CommunityPostages["AreaID"].split("、");
          var _areaNames = _CommunityPostages["AreaName"].split("、");
          var _ChinaArea = that.ChinaArea;
          var areaArr = [];
          _ChinaArea.map(function (obj, k) {
            obj["area"].map(function (ar, kk) {
              if (_areaIds.indexOf(ar["Code"]) >= 0) {
                var _name = `k-${k}-${kk}`;
                areaArr.push(_name);
                that.$set(that.tempArea, _name, ar);
              }
            });
          });
          that.tempAreaArr = areaArr;
          //遍历已选区域
        }
        that.CurCommunityPostages(); //获取已选区域
        //console.log("AddExcluded-find-tempArea-tempAreaArr", that.ChinaArea, that.tempArea, that.tempAreaArr);
      }
      that.dialogVisible = true;
    },
    selectArea(area, k, kk, type, disable) {
      var that = this;
      //区域弹框 点击选择区域
      /*
       * tempArea 临时存储区域列表 {'k-0-1':{},'k-0-2':{}}
       * tempAreaArr 临时存储区域对应key ['k-0-1','k-0-2'] 第一层第index（0）个中的第index（1）个
       */
      //console.log(type);
      //that.tempArea = [...that.tempArea, { 'area': area, 'pk': k, 'ck': kk }];
      if (disable) {
        //已被选区域不可再选
        return false;
      }
      var _name = `k-${k}-${kk}`,
        value = "";
      if (that.tempArea[_name] == undefined || that.tempArea[_name] == "") {
        value = area;
      }
      if (type == "delt") {
        Array.prototype.remove = function (val) {
          var index = this.indexOf(val);
          if (index > -1) {
            this.splice(index, 1);
          }
        };
        that.tempAreaArr.remove(_name);
        if (that.curPostages.indexOf(area["Code"]) > -1) {
          that.curPostages.remove(area["Code"]);
        }
      } else {
        that.tempAreaArr.push(_name);
      }
      that.$set(that.FormData, "AddressVersionCode", ""); //有编辑运费 清空AddressVersionCode
      that.$set(that.tempArea, _name, value);
      //console.log("tempArea:", that.tempArea, "tempAreaArr:", that.tempAreaArr);
    },
    DelExcluded(index) {
      var that = this;
      //删除运费
      if (index != undefined) {
        that.FormData["CommunityPostages"].splice(index, 1);
        that.$set(that.FormData, "AddressVersionCode", ""); //有编辑运费 清空AddressVersionCode
        that.CurCommunityPostages(); //获取已选区域
      }
    },
    ExcludedYes() {
      var that = this;
      //区域选择 确认
      var _tempArea = that.tempArea, _tempAreaArr = that.tempAreaArr, _ChinaArea = that.ChinaArea;
      var aid = "", aname = "";
      _tempAreaArr.map(function (obj, key) {
        var areaKey = obj.split('-');
        var cArea = _ChinaArea[areaKey[1]]['area'][areaKey[2]];
        if (_tempArea[obj] && _tempArea[obj] != '') {
          aid += (key > 0 ? '、' : '') + cArea.Code;
          aname += (key > 0 ? '、' : '') + cArea.EName;
        }
      });
      if (that.E_item != "") {
        //编辑
        var index = that.E_item;
        var _CCP = that.FormData['CommunityPostages'][index];
        var _data = {
          AreaID: aid ? aid : '0',
          AreaName: aid ? aname : 'Domestic Shipping',
          Status: _CCP['Status'],//1是包邮，2是顺丰到付，3是自定义价格
          Price: _CCP['Price'],//Status 3 自定义价格
          Type: aid ? 2 : 1 //_CCP['Type']
        };
        that.$set(that.FormData['CommunityPostages'], index, _data);
      } else {
        //新增
        var _data = {
          AreaID: aid ? aid : '',
          AreaName: aid ? aname : 'No Area Selected',
          Status: 1,//1是包邮，2是顺丰到付，3是自定义价格
          Price: 0,//Status 3 自定义价格
          Type: aid ? 2 : 1 //1 是全国默认邮费 2 是国内自定义邮费
        };
        that.FormData['CommunityPostages'].push(_data);
      }
      that.tempArea = {}; that.tempAreaArr = [];//清空显示用选项
      that.$set(that.FormData, 'AddressVersionCode', '');//有编辑运费 清空AddressVersionCode
      //console.log('FormData[CommunityPostages]', that.FormData['CommunityPostages']);
      that.dialogVisible = false;
      that.E_item = "";
      that.CurCommunityPostages();//获取已选区域
    },
    ExcludedReSet() {
      var that = this;
      //运费重排及去除type3、4
      var _CommunityPostages = that.FormData['CommunityPostages'];
      //console.log("_CommunityPostages:", _CommunityPostages);
      var addDefault = function () {
        var _data = {
          AreaID: '0',
          AreaName: 'Domestic Shipping',
          Status: 0,//1是包邮，2是顺丰到付，3是自定义价格
          Price: 0,//Status 3 自定义价格
          Type: 1 //_CCP['Type']
        };
        that.FormData['CommunityPostages'].push(_data);
      }
      if (_CommunityPostages.length > 0) {
        var cp = _CommunityPostages.filter(function (obj, key) {
          if (obj['Type'] < 3) { return obj; }
        });
        var Sort = function (array, key) {
          return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
          });
        }
        var newCommunityPostages = Sort(cp, 'Type');
        that.$set(that.FormData, 'CommunityPostages', newCommunityPostages);//有编辑运费 清空AddressVersionCode
        if (newCommunityPostages.length <= 0) {
          addDefault()
        }
        that.CurCommunityPostages();//获取已选区域
      } else {
        addDefault()
      }
    },
    CurCommunityPostages() {
      //获取已选区域[0,1,2,3...] 区域已用不可再选
      var that = this;
      var curPost = [];
      that.FormData['CommunityPostages'].map(function (obj, k) {
        var c = obj['AreaID'].split('、');
        if (c.length > 0) {
          curPost = [...curPost, ...c];
        }
      });
      that.curPostages = curPost;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/postages.css";
.postages-showonly .delivery-box {
  border-bottom: none;
  padding-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/community-postages.vue